module.exports = __webpack_public_path__ + "static/media/yay-illustration-bg.e13860d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/yay-illustration-bg.svg
// module id = 2174
// module chunks = 0